module.exports = __webpack_public_path__ + "img/rsb.8cff5d9.png";